export default __webpack_public_path__ + "media/color/sumo-49d70d19.svg";